import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'
import { useFormContext } from '@context/FormContext'

const TimeSlotPicker = ({ name, options, label, ...props }) => {
  const { values, setFieldValue } = useFormContext()
  const value = get(values, name)

  const handleSelect = (selectedValue) => {
    setFieldValue(name, selectedValue)
  }

  return (
    <div className="w-full max-w-2xl mx-auto">
      {label && (
        <label className="block text-lg font-semibold text-gray-900 mb-4 text-center">
          {label}
        </label>
      )}
      <div className="flex flex-col gap-3">
        {options.map((option) => {
          const isSelected = value === option.value
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option.value)}
              className={classNames(
                'relative w-full px-6 py-4 text-left rounded-lg border-2 transition-all duration-200 cursor-pointer',
                'focus:outline-none focus:ring-2 focus:ring-offset-2',
                !isSelected && 'bg-white border-gray-300 text-gray-900 hover:border-primary-orange hover:shadow-md hover:bg-primary-warm-50',
                'active:scale-[0.98]',
                isSelected && 'time-slot-btn--selected'
              )}
            >
              <div className="flex items-center">
                <span
                  className={classNames(
                    'text-base font-medium time-slot-btn__label',
                    !isSelected && 'text-gray-900'
                  )}
                >
                  {option.label}
                </span>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

TimeSlotPicker.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string,
}

export default TimeSlotPicker

